var React = require('react');

function IconSearch (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M20.153 18.094h-1.084l-.384-.37a8.933 8.933 0 1 0-.961.961l.37.384v1.084L24.955 27 27 24.955zm-8.233 0a6.175 6.175 0 1 1 6.175-6.175 6.167 6.167 0 0 1-6.176 6.175z","transform":"translate(-3 -3)"}));
}

IconSearch.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconSearch;

IconSearch.default = IconSearch;
